export default "__VITE_ASSET__rtnrNwd$__"